export const formatErrorMessage = (e, fallback = 'Operation failed') => {
  try {
    const raw =
      (e && (e.shortMessage || e.reason || e.message)) ||
      fallback ||
      'Operation failed';
    const s = String(raw || '').replace(/\s+/g, ' ').trim();
    const low = s.toLowerCase();
    if (low.includes('action_rejected') || low.includes('user rejected') || low.includes('user denied'))
      return 'Transaction rejected';
    if (low.includes('insufficient funds')) return 'Insufficient funds';
    if (low.includes('insufficient balance')) return 'Insufficient balance';
    if (low.includes('allowance')) return 'Insufficient allowance';
    if (low.includes('overflow') || low.includes('panic(17)')) return 'Amount too large';
    if (low.includes('call_exception')) return 'Contract call failed';
    if (low.includes('bad_data')) return 'Network decode error';
    if (low.includes('network error')) return 'Network error';
    if (low.includes('exceeds shares')) return 'Exceeds shares';
    if (low.includes('not active') || low.includes('not initialized')) return 'Market not active';
    if (low.includes('wallet not connected')) return 'Wallet not connected';
    const cut = s.split(' (action=')[0];
    return cut.length > 160 ? cut.slice(0, 160) : cut;
  } catch {
    return fallback;
  }
};
